<template>
    <v-dialog fullscreen v-model="dialog" transition="dialog-bottom-transition">
        <v-card tile flat v-if="assignedRoutine">
            <v-app-bar dark flat fixed>
                <v-row align="center" no-gutters>
                    <v-col cols="10" class="app-title text-truncate">
                        {{ routineName }}
                    </v-col>
                    <v-col cols="2" align="right">
                        <v-btn color="primary" icon @click="hide">
                            <v-icon>$close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-app-bar>

            <v-sheet height="72" color="transparent"/>

            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-row>
                            <v-col cols="12">
                                <v-img eager contain class="img-routine" :src="routineImg"/>
                            </v-col>
                            <!-- BASIC INFO -->
                            <v-col cols="12">
                                <v-row class="text-center" no-gutters>
                                    <v-col cols="4" class="kimsa-elevation py-3">
                                        <div class="first-row">
                                            {{ $tc(`common.minutes`, 2) }}
                                        </div>
                                        <div class="second-row">
                                            {{ routineDuration }}
                                        </div>
                                    </v-col>
                                    <v-col cols="4" class="kimsa-elevation py-3">
                                        <div class="first-row">
                                            {{ $tc(`common.blocks`, 2) }}
                                        </div>
                                        <div class="second-row">
                                            {{ assignedRoutine.blocks.length }}
                                        </div>
                                    </v-col>
                                    <v-col cols="4" class="kimsa-elevation py-3">
                                        <div class="first-row">
                                            {{ $tc('objectives.objectives', 1) }}
                                        </div>
                                        <div class="second-row">
                                            {{ objective }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- EQUIPMENTS -->
                            <v-col cols="12" v-if="equipments.length > 0">
                                <div class="equipments text-center">
                                    {{ $t('equipments.equip') }}
                                </div>
                                <div class="text-center">
                                    <v-chip v-for="(equip,i) in equipments" :key="i" label outlined class="mr-1 mt-1">
                                        <v-img :src="equipImg(equip)" eager contain max-width="15" class="mr-3"/>
                                        {{ equip }}
                                    </v-chip>
                                </div>
                            </v-col>
                            <!-- BUTTON -->
                            <v-col v-if="!isMobile">
                                <v-btn @click="toRoutineDetail" color="primary" class="normal-btn black--text" block depressed
                                       large>
                                    {{ startLabel }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>

                    <!-- BLOCKS -->
                    <v-col cols="12" md="6" class="mt-3">
                        <routine-blocks force-cols12 :default-blocks="blocks" readonly is-second-dialog/>
                        <v-sheet v-if="isMobile" height="72" color="transparent"/>
                    </v-col>
                </v-row>

                <div v-if="isMobile" class="bottom-button">
                    <v-btn @click="toRoutineDetail" color="primary" class="normal-btn black--text" block depressed
                           large>
                        {{ startLabel }}
                    </v-btn>
                </div>

            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

import {db} from '@/utils/Firebase'
import {mapState, mapMutations, mapActions} from 'vuex'
import RoutineBlocks from "@/components/coach/routines/RoutineBlocks";
import {blockUniqueTime} from "@/utils/Exercises";

export default {
    components: {
        RoutineBlocks,
    },
    data() {
        return {
            dialog: false,
            assignedRoutine: null,
            routine: null,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'equipment']),
        routineImg(vm = this) {
            return vm.routine?.img || vm.assignedRoutine?.img || vm.imgPlaceholder
        },
        objective(vm = this) {
            return vm.assignedRoutine?.description?.objective || vm.routine?.description?.objective || vm.$t('common.not_available_short')
        },
        equipments(vm = this) {
            return vm.assignedRoutine?.description?.equipments || vm.routine?.description?.equipments || []
        },
        routineName(vm = this) {
            return vm.assignedRoutine?.name || vm.routine?.name || ''
        },
        hasPreAssignedRoutineData(vm = this) {
            return !!(vm.assignedRoutine?.advance?.pre)
        },
        hasPostAssignedRoutineData(vm = this) {
            return !!(vm.assignedRoutine?.advance?.post)
        },
        startLabel(vm = this) {
            if (vm.hasPreAssignedRoutineData && vm.hasPostAssignedRoutineData) return vm.$t('common.see_again')
            if (vm.hasPreAssignedRoutineData) return vm.$t('common.continue')
            return vm.$t('common.start')
        },
        routineDuration(vm = this) {
            if (!vm.assignedRoutine) return vm.$t('common.not_available_short')

            let minutes = 0

            vm.assignedRoutine.blocks.forEach(block => {
                block.exercises.forEach(exercise => {
                    minutes += exercise?.config?.sets?.length || block.sets || 0
                })
            })

            let minutesAdded = Number(minutes * 1.3).toFixed()

            if (Number(minutes) === Number(minutesAdded)) return minutes
            return `${minutes} - ${minutesAdded}`
        },
        blocks(vm = this) {
            return blockUniqueTime(vm.assignedRoutine?.blocks || [])
        }
    },
    async mounted() {
        let vm = this
        if (vm.equipment.length === 0) await vm.bindEquipment()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        ...mapActions(['bindEquipment']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.assignedRoutine = null
            vm.routine = null
        },
        async setRoutine(routine) {
            const vm = this
            vm.assignedRoutine = routine
            if (routine.routineId) {
                let routineRef = await db.collection('routines').doc(routine.routineId).get()
                vm.routine = routineRef.data()
            }
        },
        toRoutineDetail() {
            const vm = this
            if (!vm.assignedRoutine) return null
            vm.$router.push({name: 'student.routine.detail', params: {uid: vm.assignedRoutine.id}})
        },
        equipImg(equip) {
            let vm = this
            return vm.equipment?.find(el => el.name === equip)?.src || vm.imgPlaceholder
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}

</script>

<style scoped>

.img-routine {
    margin-top: -16px;
    background-color: rgba(0, 0, 0, .1);
    height: 200px;
}

.app-title {
    font-size: 20px;
}

.v-divider {
    height: 2px;
    max-height: 10px;
    background-color: var(--v-primary-base);
    margin: 10px 35%;
}

.bottom-button {
    display: flex;
    position: fixed;
    bottom: 0%;
    left: 0%;
    width: 100%;
    padding: 10px;
    background-color: #333333;
    z-index: 6;
}

.first-row {
    font-size: 13px;
    line-height: 20px;
    font-weight: bold;
    text-transform: uppercase;
    color: #666666;
}

.second-row {
    font-size: 17px;
    line-height: 22px;
    font-weight: bold;
    color: #666666;
}

.equipments {
    font-size: 14px;
}

</style>